import {create} from 'zustand';

type GuardianStep = 1 | 2;

type GuardianState = {
	guardianStep: GuardianStep;
	selectedGuardianId: number | null;
	setGuardianStep: (step: GuardianStep) => void;
	setSelectedGuardianId: (personId: number | null) => void;
	reset: () => void;
};

export const useGuardianStore = create<GuardianState>(set => ({
	guardianStep: 1,
	selectedGuardianId: null,
	setGuardianStep: step => set({guardianStep: step}),
	setSelectedGuardianId: personId => set({selectedGuardianId: personId}),
	reset: () => set({guardianStep: 1, selectedGuardianId: null}),
}));
